module.exports = __webpack_public_path__ + "assets/img/3.43157ad3.png";